module.exports = __webpack_public_path__ + "img/anxiety.f6d2e133.jpg";